import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className='container services_container'>
        <article className='service'>
          <div className="service_head">
            <h3> WEB DEVELOPMENT</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Full-Stack Application: </h4>
              <small className='text-light'>Custom web apps built from scratch /(React, Node.js, Databases).</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Frontend Engineering: </h4>
              <small className='text-light'>Pixel-perfect, responsive UI layout creation (HTML/CSS/JS).</small>            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>API Integration: </h4>
              <small className='text-light'>Building and connecting secure RESTful/GraphQL APIs and 3rd-party services.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Performance Tuning: </h4>
              <small className='text-light'>Optimizing site speed, code structure, and responsive behavior.</small>
            </li>
          </ul>
        </article>
        {/* END OF WEB DEVELOPMENT */}

        <article className='service'>
          <div className="service_head">
            <h3> MOBILE DEVELOPMENT</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Native App Development: </h4>
              <small className='text-light'>Platform-specific, high-performance apps using Swift (iOS) or Kotlin (Android).</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Cross-Platform Development: </h4>
              <small className='text-light'>Building apps that run on multiple platforms with a single codebase (React Native, Flutter).</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>UI/UX Design: </h4>
              <small className='text-light'>Creating intuitive and visually appealing mobile user interfaces.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>App Maintenance: </h4>
              <small className='text-light'>Ongoing support and updates for existing mobile applications.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>App Store Deployment: </h4>
              <small className='text-light'>Guided submission process for app stores (Apple App Store, Google Play Store).</small>
            </li>
          </ul>
        </article>
        {/* END OF MOBILE DEVELOPMENT */}

        <article className='service'>
          <div className="service_head">
            <h3> INTERNET OF THINGS</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Firmware Programming: </h4>
              <small className='text-light'>Writing low-level, memory-efficient code (C/C++, MicroPython) for Arduino, ESP32, and Raspberry Pi.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Hardware Integration: </h4>
              <small className='text-light'>Connecting and configuring various hardware, sensors, and physical components.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Network Configuration: </h4>
              <small className='text-light'>Setting up and managing communication networks for connected devices.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Data Analytics: </h4>
              <small className='text-light'>Collecting, processing, and analyzing data from IoT devices to derive insights.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Cloud Integration: </h4>
              <small className='text-light'>Connecting IoT devices to cloud platforms for data storage and management.</small>
            </li>
          </ul>
        </article>
        {/* END OF INTERNET OF THINGS */}
     

      <article className='service'>
          <div className="service_head">
            <h3> ARTIFICIAL INTELLIGENCE</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Custom Machine Learning Models: </h4>
              <small className='text-light'>Developing and training custom ML models for specific use cases.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Data Engineering: </h4>
              <small className='text-light'>Extracting, cleaning, and structuring messy business data using Pandas & NumPy.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>Smart AI Integration: </h4>
              <small className='text-light'>Integrating AI capabilities into existing systems and applications.</small>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>End-to-End AI Solutions: </h4>
              <small className='text-light'>Architecting smart systems by combining Data Science for predictive business analytics, Deep Learning for neural networks and LLM-driven automation, and Computer Vision for real-time image and video processing.</small>
            </li>
            

            <li>
              <BiCheck className='service_list-icon'/>
              <h4>MLOps Deployment: </h4>
              <small className='text-light'>Deploying and managing machine learning models in production environments.</small>
            </li>
          </ul>
        </article>
        {/* END OF ARTIFICIAL INTELLIGENCE */}

   </div>
    
    </section>
  )
}

export default services